import { render, staticRenderFns } from "./buyRequests.vue?vue&type=template&id=4d25fa72&"
import script from "./buyRequests.vue?vue&type=script&lang=js&"
export * from "./buyRequests.vue?vue&type=script&lang=js&"
import style0 from "./buyRequests.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports